


















































import { Vue, Component, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import RgTemplateModal from './rgTemplateModal.vue';
import { pick } from 'lodash';

@Component({
    components: {
        RgTemplateModal
    }
})
export default class RgTemplateTable extends Vue {
    @Prop({ required: true })
    api: string;
    @Prop({ required: true })
    title: string;
    tableLoading: boolean = false;
    list: any = [];
    openModal: boolean = false;
    formData: any = {};
    currentPageMore: number = 1;
    currentPageSize: number = 10;
    tn: number = 0;
    created() {
        this.getItemList();
    }
    async getItemList() {
        const action = `get${this.api}`;
        const { code, data } = await api.rgApi[action]({
            rgId: this.$route.query.rgId,
            cn: this.currentPageMore,
            sn: this.currentPageSize
        });
        if (code === 200) {
            this.tn = data.tn;
            this.list = data.items;
        }
    }
    change(current, size) {
        this.currentPageMore = current;
        this.currentPageSize = size;
        this.getItemList();
    }
    handleSwitchChange(val) {
        this.addItemHandler(val);
    }
    async addItemHandler(val) {
        let action = '';
        const keys = ['rgId', 'title', 'content', 'enable', 'id'];
        this.closeModalHandler(false);
        if (val.id) {
            action = `update${this.api}`;
        } else {
            action = `add${this.api}`;
        }
        const { code } = await api.rgApi[action](pick(val, keys));
        if (code === 200) {
            this.$mtd.message.success('操作成功');
            this.getItemList();
        }
    }
    handleOperation(obj?: any) {
        if (obj && obj instanceof Object) {
            this.formData = obj;
        } else {
            this.formData = {};
        }
        this.openModal = true;
    }
    closeModalHandler(val) {
        this.openModal = val;
    }
}
